<template>
  <div class="dialog-wrap">
    <div class="filter">
      <el-form
        :inline="true"
        :model="formSearch"
        ref="formSearch"
        class="demo-form-inline"
      >
        <div style="display: flex">
          <el-form-item style="width: 330px; margin-right: 12px">
            <product-select
             :value.sync="formSearch.afid"
              style="width: 100%"
              placeholder="请选择产品"
              @change="handerAfid"
              :isDefault="true"
              popper-class="BI-select BI-select-product"
            >
            </product-select>
          </el-form-item>
          <el-form-item style="flex: 1">
            <el-select
              v-model="formSearch.media"
              placeholder="全部"
              multiple
              collapse-tags
              @change="changeSelect"
              class="multipleselect"
              ref="chnlref"
              style="width: 100%"
              popper-class="app-select-self"
            >
              <div class="input-search">
                <el-input
                  v-model="text"
                  size="mini"
                  suffix-icon="el-icon-search"
                />
              </div>
              <el-checkbox
                v-model="checked"
                @change="selectAll($event, 'check')"
                >全选</el-checkbox
              >
              <div @click="clickclear" class="clearbutton">
                <span style="font-size: 14px">清空</span>
              </div>

              <el-option
                v-for="item in mediaList.filter(
                  (i) => !text || i.toLowerCase().includes(text.toLowerCase())
                )"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="display: flex">
          <el-form-item style="width: 330px; margin-right: 12px">
            <el-select
              style="width: 100%"
              v-model="formSearch.geo"
              filterable
              placeholder="请选择"
              popper-class="BI-select BI-select-geo"
            >
              <el-option label="全部" :value="null"></el-option>
              <el-option
                v-for="item in countryList"
                :key="item.geo"
                :label="`${item.name} ${item.geo}`"
                :value="item.geo"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  item.geo
                }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="flex: 1">
            <el-date-picker
              v-model="formSearch.formdate"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="table">
      <el-table
        :show-header="false"
        size="mini"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column prop="date" width="280" align="center">
          <template slot-scope="scope"> Day {{ scope.row }}</template>
        </el-table-column>
        <el-table-column prop="value">
          <template slot-scope="scope">
            <el-input-number
              :max="1"
              :step="0.01"
              style="width: 100%"
              placeholder="请输入"
              :controls="false"
              controls-position="right"
              v-model="dayValueList[scope.$index]"
              clearable
            >
            </el-input-number>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { changeshortcutclass, clearallshortcutclass } from "@/utils/tool";
import moment from "moment";
import { inputPredictData } from "@/api/api";
export default {
  components: {},

  data() {
    return {
      countryList: [],
      checked: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("当天", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一周", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一个月", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近2个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近2个月", picker.$el);
              }, 0);
            },
          },
        ],
        onPick: function ({ maxDate, minDate }) {
          clearallshortcutclass(this.$el);
          console.log(maxDate, minDate);
        },
        disabledDate: function (date) {
          if (new Date().getTime() - date.getTime() > 0) {
            return false;
          }
          return true;
        },
        // disabledDate: function(time) {
        //   return time.getTime() > Date.now();
        // }
      },
      text: "",
      formSearch: {
        formdate: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 6),
          new Date(),
        ],
        afid: null,
        geo: null,
        media: [],
      },
      dayValueList: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
      tableData: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
      ],
    };
  },

  computed: {
    mediaList: function () {
      return this.$store.state.Summary.mediaList;
    },
  },

  watch: {},

  mounted: function () {
    this.formSearch = {
      formdate: [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * 6),
        new Date(),
      ],
      afid: null,
      geo: null,
      media: [],
    };
    const timer = setInterval(() => {
      if (this.formSearch.afid) {
        clearInterval(timer);
        this.$store.dispatch("getCountryListAndMedia", {
          afid: this.formSearch.afid,
          cb: (result) => {
            this.countryList = result.countryList;
            let param = {
              pageSize: 500,
              pageNumber: 1,
              dateStart: moment(this.formSearch.formdate[0]).format("YYYYMMDD"),
              dateEnd: moment(this.formSearch.formdate[1]).format("YYYYMMDD"),
              afid: this.formSearch.afid,
              geo: this.formSearch.geo,
              media: this.formSearch.media.length
                ? this.formSearch.media.join()
                : null,
            };
            // getalldimensiondataFetch({ data: JSON.stringify(param) }).then(
            //   (res) => {
            //     console.log(res);
            //     this.$emit("showLoading", false);
            //     this.$emit("refreshTable");
            //   }
            // );
            this.$emit("refreshTable", param);
            // this.$store.dispatch("getSummaryList", {
            //   param,
            //   cb: () => {
            //     this.$emit("showLoading", false);
            //     this.$emit("refreshTable");
            //   },
            // });
          },
        });
      }
    }, 200);
  },

  methods: {
    saveLtData() {
      let retentions = {};
      const index = this.dayValueList
        .slice(0, 7)
        .findIndex((item) => item === 0);
      if (index > -1) {
        this.$message.error("day1至day7为必填且不能等于0");
        return;
      }
      this.dayValueList.map((item, index) => {
        retentions["day" + (index + 1)] = item;
      });
      inputPredictData({
        retentions,
        startDate: moment(this.formSearch.formdate[0]).format("YYYYMMDD"),
        endDate: moment(this.formSearch.formdate[1]).format("YYYYMMDD"),
        afidList: [this.formSearch.afid],
        geoList: [this.formSearch.geo],
        msList: this.formSearch.media,
      }).then((res) => {
        if (res.code === "0000") {
          this.$emit("successCallback", this.formSearch, res.data);
        }
      });
    },
    resetData() {
      this.dayValueList = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ];
    },
    clickclear() {
      this.formSearch.media = [];
    },
    changeSelect(value) {
      if (
        this.checked &&
        this.formSearch.media.length <
          this.$store.state.Summary.mediaList.length
      ) {
        this.checked = false;
        this.formSearch.media = value;
      }
    },
    selectAll(event, value) {
      if (event) {
        this.formSearch.media = this.$store.state.Summary.mediaList;
      } else {
        value == "check" ? (this.formSearch.media = []) : null;
      }
    },
    handerAfid(e) {
      this.formSearch.geo = null;
      this.$store.dispatch("getCountryList", {
        afid: e,
        cb: (result) => {
          this.countryList = result;
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@borderline: #e6e6e6;
.el-date-editor--daterange {
  width: 483px;
}
.el-button {
  margin-left: 14px;
}
.userheder {
  padding: 10px;
  margin: 2px;
  border-radius: 3px;
  align-items: baseline;
}
/deep/ .el-form-item__content {
  width: 100%;
}
/deep/ .el-form-item {
  margin-right: 0px;
}
.headerleft {
  text-align: right;
  i {
    font-size: 20px;
    margin-right: 10px;
    cursor: pointer;
  }
  i:hover {
    color: #409eff;
  }
}
.el-checkbox {
  width: 95%;
  text-align: right;
}
.input-search {
  width: 90%;
  margin-left: 5%;
}
.clearbutton {
  display: flex;
  padding: 0 20px;
  height: 34px;
  line-height: 34px;
  box-sizing: border-box;

  &:hover {
    background: #f5f7fa;
    cursor: pointer;
  }
}
.table {
  height: 300px;
  background: red;
  overflow-y: auto;
  /deep/ .el-table td {
    padding: 2px 0;
  }
}
</style>
